import React from 'react';

const FundingTab = ({ project }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Funding & Grants</h3>
        <button className="px-4 py-2 bg-green-600 dark:bg-green-700 text-white rounded-md hover:bg-green-700 dark:hover:bg-green-800">
          Find New Grants
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {(project.project_grants || []).map((grant) => (
          <div
            key={grant.id}
            className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700"
          >
            <div className="flex justify-between items-start">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white">
                  {grant.grants?.title || 'Grant'}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  Type: {grant.grants?.funding_type || 'Unknown'} | Jurisdiction:{' '}
                  {grant.grants?.jurisdiction || 'N/A'}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Amount: ${grant.amount_aud?.toLocaleString() || 'TBD'}
                </p>
              </div>
              <span
                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  grant.status === 'approved'
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                    : grant.status === 'applied'
                    ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
                    : grant.status === 'rejected'
                    ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                    : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
                }`}
              >
                {grant.status.toUpperCase()}
              </span>
            </div>
            {grant.application_url && (
              <div className="mt-4">
                <a
                  href={grant.application_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm"
                >
                  View Application →
                </a>
              </div>
            )}
            {grant.notes && (
              <div className="mt-2 text-sm text-gray-600 dark:text-gray-400">{grant.notes}</div>
            )}
          </div>
        ))}
        {(!project.project_grants || project.project_grants.length === 0) && (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            No grants linked yet. Consider applying for relevant energy efficiency grants.
          </div>
        )}
      </div>
    </div>
  );
};

export default FundingTab;


